module.exports = __webpack_public_path__ + "static/media/user.78cf5b55.svg";